// src/App.js
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Gallery from './components/Gallery';

import ContactForm from './components/ContactForm';
import ParallaxSection from './components/Parallax';
import Footer from './components/Footer';

import parallaxImage1 from './assets/p8.jpg'; 
import parallaxImage2 from './assets/p1.jpg'; 
import parallaxImage3 from './assets/p2.jpg'; 
import parallaxImage4 from './assets/boutus.jpg';
import Download from './components/Download';
const App = () => {
  return (
    <Router>
      <div id="home">
        <Header />
        <Hero />
          <ParallaxSection imageUrl={parallaxImage4}>
        <About />
 </ParallaxSection>
        {/* Parallax background section with Services inside */}
        <ParallaxSection imageUrl={parallaxImage1}>
          <Services />
          </ParallaxSection>
        
        <Gallery />
       
        <ParallaxSection imageUrl={parallaxImage2}>
        <Download />
        </ParallaxSection>
        <ParallaxSection imageUrl={parallaxImage3}>
        <ContactForm />
        </ParallaxSection>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
